<template>
  <div>
      <el-row
    type="flex"
    justify="center"
    align="middle"
    style="height: 100vh">
    <el-form
      id="login_form"
      :model="login_information"
      :rules="rules"
      ref="login_information"
      :hide-required-asterisk="true">
      <img id="logo" src="../assets/logo.png" alt="">
      <el-form-item prop="username">
        <el-input
          :clearable="true"
          style="width: 200px"
          v-model="login_information.username"
          prefix-icon="el-icon-user">
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="login_information.password"
          style="width: 200px"
          show-password=""
          prefix-icon="el-icon-lock">
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          @click="submit('login_information')"
          size="mini"
          :loading="loading">登录</el-button>
        <el-button @click="dialogVisible = true" size="mini">注册</el-button>
      </el-form-item>
    </el-form>
    <el-dialog title="注册" :visible.sync="dialogVisible" width="400px" class="register-form">
      <el-form :model="registForm" :rules="rules" ref="registForm" label-width="100px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="registForm.username"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-tooltip content="必须为团小蜜已注册团长所对应手机号" placement="right" effect="light">
            <el-input v-model="registForm.phone"></el-input>
          </el-tooltip>
        </el-form-item>
        <el-form-item label="邀请码" prop="cipher">
          <el-input v-model="registForm.cipher"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="registForm.password"
            type="text"
            onfocus="this.type='password'"
            autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input
            v-model="registForm.checkPass"
            type="text"
            onfocus="this.type='password'"
            autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="registSubmit('registForm')">确 定</el-button>
      </div>
    </el-dialog>
  </el-row>
  <a href="https://beian.miit.gov.cn/" target="_blank" class="record_num">京ICP备15013736号-15</a>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data () {
    const patrn = /^[A-Za-z0-9]+$/
    const validatePass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('密码不能为空'))
      } else if (!patrn.test(value)) {
        callback(new Error('密码只能为英文或数字'))
      } else {
        callback()
      }
    }
    const validatePass2 = (rule, value, callback) => {
      if (value !== this.registForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      LoginURL: this.getDomain() + 'bmuser/login', // 登录
      RegistURL: this.getDomain() + 'bmuser/regist', // 注册
      loading: false,
      dialogVisible: false,
      login_information: {
        username: '',
        password: ''
      },
      registForm: {
        username: '',
        phone: '',
        cipher: '',
        password: '',
        checkPass: ''
      },
      rules: {
        username: [
          { required: true, message: '账号不能为空' }
        ],
        phone: [
          { required: true, message: '手机号码不能为空' }
        ],
        cipher: [
          { required: true, message: '邀请码不能为空' }
        ],
        password: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 登录
    submit (formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios.post(this.LoginURL, {
            username: this.login_information.username,
            password: this.login_information.password
          }).then((data) => {
            if (data.data.err_code === 0) {
              sessionStorage.token = data.data.content.user.token
              sessionStorage.username = this.login_information.username
              localStorage[`$_${this.getDomain()}type`] = data.data.content.user.type
              this.$router.push(localStorage[`$_${this.getDomain()}type`] === '2' ? '/navmenu/GoodPlatform/new-good' : '/navmenu/DashBoard/client')
            } else if (data.data.err_code === 50001) {
              this.$alert('用户名或密码错误', '登录失败', {
                confirmButtonText: '确定'
              })
              this.loading = false
            } else {
              this.$alert('请检查网络', '登录失败', {
                confirmButtonText: '确定'
              })
              this.loading = false
            }
          })
        } else {
          this.$alert('用户名或密码格式不对', '登录失败', {
            confirmButtonText: '确定'
          })
          this.loading = false
        }
      })
    },
    // 注册
    registSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios.post(this.RegistURL, {
            cipher: this.registForm.cipher,
            phone: this.registForm.phone,
            username: this.registForm.username,
            password: this.registForm.password,
            type: 0
          }).then((data) => {
            if (data.data.err_code === 0) {
              this.$alert('注册成功', '成功', {
                confirmButtonText: '确定'
              }).then(() => {
                this.dialogVisible = false
                this.type = 'text'
              })
            } else {
              this.$alert('注册失败', '失败', {
                confirmButtonText: '确定'
              }).then(() => {
                this.type = 'text'
              })
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.record_num{
  text-align: center;  position: fixed;
  bottom: 20px;
  text-decoration: none;
  color: black;
  left: 50%;
  transform: translate(-50%,0);
}
</style>
